module.exports = __webpack_public_path__ + "static/media/fb.518787bf.svg";